// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__QFCDz","title":"Info_title__sZPCM","links":"Info_links__1CWck","link":"Info_link__3gk42","logo":"Info_logo__1SN_b"};